// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"a0b258bc","453":"a6626cb3","806":"15ce1438"}[chunkId] + ".chunk.js";
};